
import React from "react";
import AgentFormContainer from "./agent-form/AgentFormContainer";

const AgentUploadForm: React.FC = () => {
  return <AgentFormContainer />;
};

export default AgentUploadForm;
